<div class="wrapper">
  <div class="quantity-input">
    <app-number-input
      [error]="form.controls.quantity.errors?.required ? 'This field is required' : null"
      [label]="'USED (' + uom + ')'"
      [parentFormGroup]="form"
      controlName="quantity"
      />
  </div>
  @if (!!form.controls['comment']) {
    <div
      class="comment-section"
      >
      <app-text-area
        [parentFormGroup]="form"
        controlName="comment"
        label="COMMENT"
        />
    </div>
  }
  @if (selectedMediaFiles.length) {
    <app-pictures-section
      (onDelete)="deletePicture($event)"
      [pictures]="selectedMediaFiles"
      class="pictures-section"
      />
  }
  @if (showLocationSection()) {
    <app-location-station-card
      (onDelete)="deleteLocation()"
      [latitude]="form?.controls?.latitude?.value"
      [longitude]="form?.controls?.longitude?.value"
      [locationText]="form?.controls?.location?.value"
      [stationRange]="form?.controls?.station_range?.value"
      [form]="form"
      class="location-section"
      />
  }
</div>
